module.exports = __webpack_public_path__ + "img/269-4.96078e64.jpg";